module.exports = __webpack_public_path__ + "media/images/failure-1-284f8de1d8e64873e034ca9ac1af309e.png";